// Carry Roll ProfilesPanel — saved profiles + swing-speed presets (8.1, 8.2, 8.7).

import { useStore } from '../../store';
import { degToRad } from '@carry-roll/shared-logic';
import { ClubCategory, Fidelity, Firmness, LandingSurface, SurfaceMoisture, type SimulationRequest } from '@carry-roll/shared-types';

const amateurPreset: SimulationRequest = {
  launch: { ballSpeed: 43.8, launchAngle: degToRad(12), spinRpm: 3200, clubSpeed: 42, spinAxisDeg: 0, launchDirDeg: 0, apexHint: null },
  delivery: null,
  environment: {
    altitudeM: 0, temperatureK: 293.15, windSpeed: 0, windDirDeg: 0,
    firmness: Firmness.Normal, moisture: SurfaceMoisture.Normal, landingSurface: LandingSurface.Fairway,
    landingSlopeDeg: 0, crossSlopeDeg: 0, elevationDiffM: 0, seaLevelBaseline: false, humidity: 0.5, pressurePa: 101325,
  },
  override: { landingAngleDeg: null },
  club: { category: ClubCategory.Driver, loftDeg: 10.5, rollPercent: null },
  fidelity: Fidelity.Full,
  ballType: 'tour',
};

const proPreset: SimulationRequest = {
  launch: { ballSpeed: 50.1, launchAngle: degToRad(10), spinRpm: 2600, clubSpeed: 48, spinAxisDeg: 0, launchDirDeg: 0, apexHint: null },
  delivery: null,
  environment: amateurPreset.environment,
  override: { landingAngleDeg: null },
  club: { category: ClubCategory.Driver, loftDeg: 10.5, rollPercent: null },
  fidelity: Fidelity.Full,
  ballType: 'tour',
};

export function ProfilesPanel() {
  const profiles = useStore((s) => s.profiles);
  const saveProfile = useStore((s) => s.saveProfile);
  const loadProfile = useStore((s) => s.loadProfile);
  const request = useStore((s) => s.request);

  return (
    <div data-testid="profiles-panel">
      <h3 className="subsection-title">
        Profiles ({profiles.length})
      </h3>
      <button
        type="button"
        className="btn btn-primary mb-2"
        onClick={() =>
          saveProfile({
            id: `p-${Date.now()}`,
            name: `Profile ${profiles.length + 1}`,
            request,
            result: useStore.getState().result,
            source: 'manual',
            createdAt: Date.now(),
            updatedAt: Date.now(),
          })
        }
      >
        Save current as profile
      </button>
      {profiles.length === 0 ? (
        <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          No profiles saved yet. Click &quot;Save current as profile&quot; above.
        </p>
      ) : (
        <ul className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
          {profiles.map((p) => (
            <li
              key={p.id}
              style={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              • {p.name} ({p.source})
            </li>
          ))}
        </ul>
      )}
      <div className="mt-2 text-xs" style={{ color: 'var(--color-text-muted)' }}>
        Swing-speed presets:{' '}
        <button type="button" className="btn" onClick={() => loadProfile(amateurPreset)}>Amateur</button>{' '}
        <button type="button" className="btn" onClick={() => loadProfile(proPreset)}>Pro</button>
      </div>
    </div>
  );
}
